import { Box, Grid } from "@mui/material";
import Hero from "../../../components/display/Hero";
import UserHomePageAppointments from "./userHomePage/UserHomePageAppointments";
import UserHomePagePets from "./userHomePage/UserHomePagePets";

export default function UserDesktopHomePage() {
  return (
    <>
      <Hero height="25vh" />
      <Box
        sx={{
          ml: 5,
          mr: 5,
          mb: { sm: 5, md: 5 },
          minHeight: { xs: "auto", sm: "auto", md: "800px" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Grid container spacing={2} sx={{ height: "100%", mb: "3" }}>
          <Grid item xs={12} sm={12} md={8} lg={8} sx={{ height: "100%" }}>
            <UserHomePageAppointments />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            lg={4}
            sx={{ minHeight:"100%"}}
          >
            <UserHomePagePets />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
